"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxFormTypes = exports.InvestorTypes = exports.AccreditedStatuses = exports.KycProviders = exports.Genders = void 0;
exports.Genders = {
    MALE: 'male',
    FEMALE: 'female',
    EMPTY: '',
};
exports.KycProviders = {
    INTERNAL: 'internal',
    SECURITIZE_ID: 'securitize-id',
    BROKERDEALER: 'brokerdealer',
};
exports.AccreditedStatuses = {
    NONE: 'none',
    PENDING: 'pending',
    VERIFIED: 'verified',
    REJECTED: 'rejected',
    NO: 'no',
    EXPIRED: 'expired',
    UPDATES_REQUIRED: 'updates-required',
    PROCESSING: 'processing',
    NOT_ACCREDITED: 'not-accredited',
};
exports.InvestorTypes = {
    INDIVIDUAL: 'individual',
    ENTITY: 'entity',
    FBO_INDIVIDUAL: 'fbo-individual',
    FBO_ENTITY: 'fbo-entity',
    NONE: 'none',
};
exports.TaxFormTypes = {
    W9: 'W-9',
    W8BEN: 'W-8BEN',
    W8BENE: 'W-8BENE',
    '1042S': '1042-S',
    '1099B': '1099-B',
    '1099DIV': '1099-DIV',
    '1099INT': '1099-INT',
    '1099K': '1099-K',
    '1099MISC': '1099-MISC',
};
//# sourceMappingURL=investor.js.map